// Imports
import { faPaperclip } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components/macro';


// Styled components
const Attachment = styled.div`
	display: inline-block;
	
	> a {
		padding-left: 0.3rem;
		padding-right: 0.6rem;
		
		> svg {
			padding-right: 0.2rem;
		}
	}
`;


// Define the accepted props
interface Attachment {
	name: string;
	filename: string;
}

interface Props {
	id: number;
	attachments: Attachment[] | null;
	attachmentURIPrefix?: string;
}


// Function component
const Attachments: React.FC<Props> = ({ id, attachments, attachmentURIPrefix }) => {
	return (
		<React.Fragment>
			{attachments?.map((attachment, i) => (
				<Attachment key={i}>
					<a
						href={`https://${window.location.hostname}/private-files/${
							attachmentURIPrefix ? `${attachmentURIPrefix}-` : ''
						}attachment/${id}/${window.encodeURIComponent(attachment.filename)}/${window.encodeURIComponent(
							attachment.name
						)}`}
					>
						<FontAwesomeIcon icon={faPaperclip} />
						{attachment.name}
					</a>
				</Attachment>
			))}
		</React.Fragment>
	);
};

export default Attachments;
